module.exports = __webpack_public_path__ + "img/Kaku.5d023ef3.png";